export default class UnloadAnswerPerformance {
  constructor(context) {
    this.context = context;
  }

  run() {
    this.context.stores.answerPerformances.set([]);

    const appFeatures = this.context.stores.appFeatures.get();
    if (appFeatures.isEnabled('viewAnswerPerformance') || appFeatures.isEnabled('answers:admin')) {
      this.context.gateways.recommendedAnswersCounts.unsubscribe();
    }
  }
}
